import Foryou from "../images/foryou.jpeg";
import RIPLEGEND from "../images/RipLegend.jpeg";


var foryouData = {
  headlines: {
    img: "None",
    subTitle: "None",
    Title: "India trends"

  },
  tweets: [{
    subhead: "1 · Trending",
    title: "#LobbyAttacksLimbhavali",
    nooftweets: "2,520 Tweets"
  },
  {
    subhead: "2 · Trending",
    title: "#IndiaTodayAgainstRahul",
    nooftweets: "1,238 Tweets"
  },
  {
    subhead: "3 · Trending",
    title: "#TaazaKhabarOnHotstar",
    nooftweets: "5,091 Tweets"
  },
  {
    subhead: "4 · Trending",
    title: "#omtrailer",
    nooftweets: "1,871 Tweets"
  },
  {
    subhead: "5 · Trending",
    title: "#ApnaGharWithSignatureGlobal",
    nooftweets: "2,571 Tweets"
  },
  {
    subhead: "6 · Entertainment · Trending",
    title: "Bhuvan Bam",
    nooftweets: "3,931 Tweets"
  },
  {
    subhead: "7 · K-pop · Trending",
    title: "Run BTS",
    nooftweets: "1.16M Tweets"
  },
  {
    subhead: "8 · Politics · Trending",
    title: "HBD Kameshwar Singh",
    nooftweets: "1,179 Tweets"
  },
  {
    subhead: "9 · Celebrities · Trending",
    title: "ARDH STREAMING ON ZEE5 NOW",
    nooftweets: "23.9K Tweets"
  },
  {
    subhead: "10 · Politics · Trending",
    title: "SSR Conspirators Rewarded",
    nooftweets: "54.9K Tweets"
  }]
};
export default foryouData;
